import Rand from "../../util/Rand";

export default class SoundEffect {
    /**
     * 
     * @param {number} volume 
     * @param {Array.<string>} soundPaths 
     */
    constructor(volume, soundPaths) {
        /**
         * @constant
         * @type {string}
         */
        this.volume = volume;
        /**
         * @constant
         * @type {Array.<string>}
         */
        this.soundPaths = soundPaths;
    }

    getVolume() {
        return this.volume;
    }

    getSoundPaths() {
        return this.soundPaths;
    }
    
    /**
     * @returns {string}
     */
    getRandomSoundPath() {
        if (!this.soundPaths) {
            return null;
        }

        if (this.soundPaths.length == 0) {
            return null;
        }

        if (this.soundPaths.length == 1) {
            return this.soundPaths[0];
        }
        else {            
            //return this.soundPaths[Math.floor(Math.random() * this.soundPaths.length)];

            return this.soundPaths[Rand.randomInt(this.soundPaths.length)];
        }
    }

}